import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import { KLYUCH_METKI, metkaCheloveka, ochistitDannye, perehod, privestiHranilishche } from './smenaPolzovatelya';

/**
 * СТОРОЖ СМЕНЫ ПОЛЬЗОВАТЕЛЯ — один на вкладку, над маршрутами (`s719`; правило — в
 * `smenaPolzovatelya.ts`).
 *
 * Первая загрузка вкладки: хранилище браузера приводится к вошедшему человеку (личное прежнего
 * убрано или отложено). Человек сменился при ЖИВОЙ вкладке — в соседней вкладке вошли под учёткой
 * сотрудника, вернулись к себе, вошли другим: данные прежнего человека очищаются, вкладка
 * перечитывается с домашней страницы. Соседняя вкладка узнаёт об этом сразу (событие хранилища),
 * а не через минуту на очередном опросе «кто я».
 */
export function SmenaPolzovatelya() {
  const { user } = useAuth();
  const qc = useQueryClient();
  const metkaVkladki = useRef<string | null>(null);

  useEffect(() => {
    if (!user) return;

    const novaya = metkaCheloveka(user);
    if (metkaVkladki.current === null) {
      metkaVkladki.current = novaya;
      privestiHranilishche(user);

      return;
    }

    if (metkaVkladki.current !== novaya) {
      metkaVkladki.current = novaya;
      privestiHranilishche(user);
      ochistitDannye(qc);
      perehod.naDom();
    }
  }, [user, qc]);

  useEffect(() => {
    const izSosedney = (e: StorageEvent) => {
      if (e.key !== KLYUCH_METKI || e.newValue === null || metkaVkladki.current === null) return;
      if (e.newValue !== metkaVkladki.current) {
        metkaVkladki.current = e.newValue;
        ochistitDannye(qc);
        perehod.naDom();
      }
    };
    window.addEventListener('storage', izSosedney);

    return () => window.removeEventListener('storage', izSosedney);
  }, [qc]);

  return null;
}
